<template>
  <div class="container no-access">
    <h1>
      The content you are trying to access no longer exists, or you do not have access to it.
    </h1>
    <a :href="toolkitUrls.libraryAllFolders">
      <button class="btn btn-primary">
        <i class="fa fa-repeat fa-flip-horizontal"/>
        Return to Library
      </button>
    </a>
  </div>
</template>

<script>
import { toolkitUrls } from '@/links'

export default {
  name: 'NoAccessError',
  data() {
    return {
      toolkitUrls
    }
  }
}
</script>

<style scoped>
.no-access{
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  min-height: 50vh;
}
.no-access h1 {
  width: 35rem;
  text-align: center;
  font-size: 1.25rem;
  font-style: normal;
  font-weight: 700;
  line-height: 1.875rem; /* 150% */
}
.no-access .btn {
  padding: 0.75rem 1.5rem;
  margin: 1rem;
  font-size: 1.125rem;
  font-style: normal;
  font-weight: 400;
  line-height: 1.5rem; /* 133.333% */
}

.no-access .btn i {
  margin-right: 0.25rem;
}
</style>
